module.exports = __webpack_public_path__ + "static/media/Postales-08.03a92216.png";